import 'babel-polyfill';
import Es6Promise from 'es6-promise';
import { createStore } from 'vuex'

const store = createStore({
    state() {
        return {
            userInfo: {}, //用户信息
            userVipInfo: {}, //用户信息
            icons: {}, //盒子公共图标
            vipIcon: [], //盒子vip徽标
            vipRule: '',//盒子vip规则
            sdkInfo: {},//sdk信息
            isShowDownload: true,
            indexDot: false, //圈子红点显示
            isFirstDot: true, //是否是第一次展示
            commmentContent: '', //输入弹窗内容
            searchHistroy: [], //快速搜索历史
            mineScreenPopup: true, //我的页面弹窗，是否为第一次打开
        };
    },
    mutations: {
        setUserInfo(state, data) {
            //保存用户信息
            Object.assign(state, { userInfo: data });
        },
        setUserVipInfo(state, data) {
            //保存用户信息
            Object.assign(state, { userVipInfo: data });
        },
        setIcons(state, data) {
            state.icons = data;
        },
        setVipIcon(state, data) {
            state.vipIcon = data;
        },
        setVipRule(state, data) {
            state.vipRule = data;
        },
        setSdkInfo(state, data) {
            //保存用户信息
            Object.assign(state, { sdkInfo: data });
        },
        changeIsShowDownload(state, data) {
            state.isShowDownload = data;
        },
        changeIndexDot(state, data) {
            state.indexDot = data;
        },
        changeIsFirstDot(state, data) {
            state.isFirstDot = data;
        },
        changeCommmentContent(state, data) {
            state.commmentContent = data;
        },
        setSearchHistroy(state, data) {
            //先判断是否在搜索历史中，是的话把该历史记录提前
            if(state.searchHistroy.includes(data)) {
                const index = state.searchHistroy.indexOf(data);
                if (index !== -1) {
                    const item = state.searchHistroy.splice(index, 1)[0]; // 移除目标元素
                    state.searchHistroy.unshift(item); // 插入到开头
                }
            }else {
                //不是曾经用过的搜索历史，则插入到数组前面，然后保留前5个
                state.searchHistroy.unshift(data)
                if(state.searchHistroy.length > 5) {
                    //如果多于5个则只保留前五个
                    state.searchHistroy = state.searchHistroy.slice(0, 5)
                }
            }
        },
        setMineScreenPopup(state, data) {
            state.mineScreenPopup = data;
        },
    },
});


export default store;
